import request from '../request'

export function fetchList(params) {
    return request({
        url: '/project-service/area/list',
        params
    })
}

export function add(data) {
    return request({
        url: '/project-service/area/add',
        method: 'POST',
        data,
    })
}


export function fetchDetail(params) {
    return request({
        url: `/project-service/area/query/${params.id}`,
    })
}

export function edit(data) {
    return request({
        url: '/project-service/area/update',
        method: 'POST',
        data,
    })
}

export function remove(data) {
    return request({
        url: '/project-service/area/del',
        method: 'POST',
        data
    })
}

export function fetchTopList() {
    return request({
        url: '/project-service/area/topList',
    })
}